<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { t } from '@/locales/i18n'
import { SNK } from '@/helpers/helpers'
import { usePromotions } from '@/composables/usePromotions'
import { getSolfigrFields } from '@/store/solfigr/solfigr_helpers'
import RakesTables from '@/components/DataTables/v2/tables/RakesTable/RakesTables.vue'
import DialogTemplate from '@/components/Dialogs/DialogTemplate.vue'

const store = useStore()
const { userHasRbwizardPromo } = usePromotions()

const props = defineProps({
  dialog: Object,
})

const namespace = computed(() => props.dialog.namespace || null)

const close = () => {
  store.dispatch('router_rm_dialog', 'solfigr-rake-dialog')
}

const handleClick = ({ item }) => {
  const startStreet = store.getters[SNK('slfrm_startStreet', namespace.value)]

  const items = [
    [`slfrm_rakePercent_${startStreet}`, item.rakePercent],
    [`slfrm_rakeCap_${startStreet}`, item.rakeCap],
    [`slfrm_preflopRakeType`, item.preflopRakeType || getSolfigrFields().preflopRakeType.default],
  ]
  items.forEach(ii => store.commit(SNK('slfrm_set', namespace.value), { key: ii[0], value: ii[1] }))

  store.dispatch(SNK('slfrm_getTreePreview', namespace.value), {
    fromStart: true,
  })

  close()
}
</script>

<template>
  <DialogTemplate
    data-tst="solfigr_rakedialog"
    style="--dialog-content-overflow: none"
  >
    <RakesTables
      style="mh-0"
      @click:item="({ item }) => handleClick({ item })"
    />

    <template #dialog_actions>
      <a
        v-if="userHasRbwizardPromo"
        class="d-flex text-underline text-medium weight_500 h-100 align-center"
        href="https://rbwizard.com"
        target="_blank"
        >{{ t('messages.shortcut_dialog_rbwizard_promo') }}</a
      >
      <v-btn
        class="ml-auto"
        data-tst="btn_close"
        variant="text"
        @click="close"
        >{{ t('btn.close') }}</v-btn
      >
      <portal-target name="dialog_actions" />
    </template>
  </DialogTemplate>
</template>
